import { render, staticRenderFns } from "./KlarnaModal.vue?vue&type=template&id=75d031e2&"
import script from "./KlarnaModal.vue?vue&type=script&lang=js&"
export * from "./KlarnaModal.vue?vue&type=script&lang=js&"
import style0 from "./KlarnaModal.vue?vue&type=style&index=0&id=75d031e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports